/**
 * Platform-wide constants. Single source of truth for names used across
 * web (and future mobile) clients. Legacy Firestore values are preserved.
 */

/** Default tenant during single-tenant Triglav phase; becomes dynamic later. */
export const DEFAULT_TENANT_ID = 'triglav';

/** Organizations shown on the pre-login picker. */
export const SELECTABLE_TENANT_IDS = ['triglav', 'posta', 'luka_koper'];

/** Firestore role strings (unchanged from production schema). */
export const ROLES = {
  ADMIN: 'admin',
  LOCAL_ADMIN: 'local-admin',
  MEMBER: 'user',
};

/** Shared messageUnit / content scope id for tenant-wide visibility (not a chatRooms doc id). */
export const GENERAL_UNIT_ID = 'general';

/**
 * Firestore units/{id} for tenant-wide org unit (Q&A, articles, etc.).
 * System chat uses chatRooms/{tenantId}__general — see platform/chatRoomIds.js.
 */
export function generalUnitDocId(tenantId) {
  if (!tenantId || tenantId === DEFAULT_TENANT_ID) {
    return GENERAL_UNIT_ID;
  }
  return `${tenantId}__${GENERAL_UNIT_ID}`;
}

/** Whether a unit id represents tenant-wide visibility for the active tenant. */
export function isGeneralUnitId(unitId, tenantId) {
  if (!unitId) return false;
  return unitId === GENERAL_UNIT_ID || unitId === generalUnitDocId(tenantId);
}

/** Firestore top-level collection names. */
export const COLLECTIONS = {
  TENANTS: 'tenants',
  MEMBERS: 'members',
  USERS: 'users',
  UNITS: 'units',
  ARTICLES: 'articles',
  DOCUMENTS: 'documents',
  NOTICES: 'notices',
  BENEFITS: 'benefits',
  GALLERIES: 'galleries',
  POLLS: 'polls',
  QUESTIONS: 'questions',
  MESSAGES: 'messages',
  CHAT_ROOMS: 'chatRooms',
  CONTACTS: 'contacts',
  SINDIKALIST: 'sindikalist',
  NOTIFICATIONS: 'notifications',
};

/** Feature module identifiers for config-driven navigation (future). */
export const MODULE_IDS = {
  CHAT: 'chat',
  QNA: 'qna',
  POLLS: 'polls',
  NOTICES: 'notices',
  QUESTIONNAIRE: 'questionnaire',
  GALLERY: 'gallery',
  DOCUMENTS: 'documents',
  SINDIKALIST: 'sindikalist',
  ARTICLES: 'article',
  BENEFITS: 'benefits',
  CONTACTS: 'contact',
  USER_MANAGEMENT: 'user-management',
  PROFILE: 'profile',
};
